import dom from '../../utils/dom';
import DeleteCartItemButton, { OnCompleteCallbackArgs } from '../DeleteCartItemButton';
import initPaymentPlanSelection from '../payment-plans/initPaymentPlanSelection';
import initAppliedPaymentPlan from '../payment-plans/initAppliedPaymentPlan';
import Messaging from '../../tnew/ui/Messaging';

type SharedCartItemsProps = { isPaymentPlanSelectionVisible: boolean, isPaymentPlanApplied: boolean };
type TnewWindowUi = { messaging: typeof Messaging };

const { messaging }: TnewWindowUi = window.tnew.ui;

const handleDeleteCompleted = ({ redirectTo }: OnCompleteCallbackArgs) => {
  window.location.href = redirectTo;
  if (window.location.hash) {
    window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
    window.location.reload();
  }
};

function initSharedCartItems({ isPaymentPlanSelectionVisible, isPaymentPlanApplied }: SharedCartItemsProps) {
  window.history.scrollRestoration = 'manual';

  dom.findAll('.tn-cart__btn-remove').forEach((el) => new DeleteCartItemButton(el as HTMLButtonElement, handleDeleteCompleted));

  if (messaging.testHasErrorMessages()) {
    window.setTimeout(() => messaging.focusUserOnMessages());
  }

  if (isPaymentPlanApplied) {
    initAppliedPaymentPlan();
  } else if (isPaymentPlanSelectionVisible) {
    initPaymentPlanSelection();
  }
}

export default initSharedCartItems;
